import { render, staticRenderFns } from "./NonEditableContract.vue?vue&type=template&id=38c08ff1&scoped=true&"
import script from "./NonEditableContract.vue?vue&type=script&lang=js&"
export * from "./NonEditableContract.vue?vue&type=script&lang=js&"
import style0 from "./NonEditableContract.vue?vue&type=style&index=0&id=38c08ff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c08ff1",
  null
  
)

export default component.exports